import React from "react";
import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";
import Icon from "@/components/Icon";

export default function Products() {
  const { content, loading } = useContent();
  if (loading || !content) return null;
  const p = content.products || {};

  return (
    <div data-testid="page-products">
      <section className="sp-hero">
        <div className="sp-container py-16 lg:py-20">
          {p.eyebrow && <span className="sp-eyebrow">{p.eyebrow}</span>}
          <h1 className="mt-3 text-4xl lg:text-5xl font-extrabold">
            {p.title} <span className="text-gold">{p.title_accent}</span>
          </h1>
          {p.description && (
            <p className="mt-4 max-w-3xl text-slate-600 text-lg">{p.description}</p>
          )}
        </div>
      </section>

      <section className="py-16">
        <div className="sp-container space-y-14">
          {(p.categories || []).map((cat, idx) => (
            <div key={cat.title + idx} data-testid={`product-category-${idx}`}>
              <div className="flex items-center gap-4 mb-6">
                <div
                  className="w-14 h-14 rounded-2xl flex items-center justify-center"
                  style={{ background: `${cat.color}15`, color: cat.color }}
                >
                  <Icon name={cat.icon} size={28} />
                </div>
                <h2 className="text-2xl lg:text-3xl font-extrabold" style={{ color: cat.color }}>
                  {cat.title}
                </h2>
              </div>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {(cat.items || []).map((item, i) => (
                  <div key={item.title + i} className="sp-card h-full" data-testid={`product-${idx}-${i}`}>
                    <div
                      className="w-11 h-11 rounded-xl flex items-center justify-center mb-4"
                      style={{ background: `${cat.color}12`, color: cat.color }}
                    >
                      <Icon name={item.icon} size={22} />
                    </div>
                    <h3 className="text-[1.05rem] font-bold text-navy leading-snug">{item.title}</h3>
                    <p className="mt-2 text-sm text-slate-600 leading-relaxed">{item.text}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="sp-strip">
        <div className="sp-container py-14 grid md:grid-cols-2 gap-6 items-center">
          <div>
            <h3 className="text-2xl lg:text-3xl font-extrabold text-white">
              Want to license, subscribe to, or co-deploy a product?
            </h3>
            <p className="text-white/80 mt-2">
              Talk to our team — we'll tailor the right model for your organisation.
            </p>
          </div>
          <div className="md:text-right">
            <Link to="/contact" className="sp-btn-gold" data-testid="products-cta">
              Talk to Sales <Icon name="ArrowRight" size={18} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
